import { Box, Icon, Text } from '@ksyos/design-system';
import { Link as ReactRouterLink } from '@ksyos/router';
import { ProgressBar } from '../../molecules/progressBar/ProgressBar';

export function OsasQuestionnaireCard(props: {
    answers?: number;
    body: string;
    className?: string;
    isSent?: boolean;
    questions?: number;
    title: string;
    to: string;
}) {
    const to = props.isSent ? '#' : props.to;

    const progress =
        !props.isSent && props.answers && props.questions ? (props.answers * 100) / props.questions : undefined;

    return (
        <ReactRouterLink
            aria-disabled={props.isSent}
            onClick={props.isSent ? (event) => event.preventDefault() : undefined}
            style={{ pointerEvents: props.isSent ? 'none' : 'auto', textDecoration: 'none' }}
            to={to}
        >
            <Box
                backgroundColor="white"
                boxShadow="base"
                px={6}
                py={4}
            >
                <Box
                    alignItems="center"
                    display="flex"
                    gap={4}
                >
                    <div style={{ height: '54px', width: '54px' }}>
                        <img
                            alt={props.title}
                            src="/assets/images/somnology/questionnaires/questionnaire-card-icon.svg"
                            style={{ width: '54px' }}
                        />
                    </div>
                    <Box flex={1}>
                        <Text
                            color="subtle"
                            fontWeight="medium"
                        >
                            {props.title}
                        </Text>
                        <Text
                            className={props.className}
                            color="minimal"
                            size="xs"
                        >
                            {props.isSent ? 'Verzonden' : props.body}
                        </Text>
                        {progress && <ProgressBar progress={progress}></ProgressBar>}
                    </Box>
                    {props.isSent ? (
                        <Icon
                            color="success"
                            icon="checked"
                        />
                    ) : (
                        <Icon
                            color="minimal"
                            icon="caret-right-big"
                        />
                    )}
                </Box>
            </Box>
        </ReactRouterLink>
    );
}
